"use client";

import { c as _c } from "react/compiler-runtime";
import { formatFullDate } from "@/constants/constants";
import { BusRequest } from "@/types/busrequest";
import { format } from "date-fns";
import { FaBusAlt } from "react-icons/fa";
type Props = {
  request: BusRequest;
  onClick: () => void;
};
export default function VacancyTableRow(t0) {
  const $ = _c(24);
  const {
    request,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="leading-none"><FaBusAlt /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== request.companyName) {
    t2 = <td>{t1}<div className="leading-none">{request.companyName}</div></td>;
    $[1] = request.companyName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== request.start.address.address) {
    t3 = request.start.address.address.split(",").map(_temp);
    $[3] = request.start.address.address;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <td><div>{t3}</div></td>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== request.start.date) {
    t5 = format(request.start.date, formatFullDate);
    $[7] = request.start.date;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <div className="leading-none">{t5}</div>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="leading-none">-</div>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== request.end.date) {
    t8 = format(request.end.date, formatFullDate);
    $[12] = request.end.date;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <div className="leading-none">{t8}</div>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t6 || $[17] !== t9) {
    t10 = <td>{t6}{t7}{t9}</td>;
    $[16] = t6;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== onClick || $[20] !== t10 || $[21] !== t2 || $[22] !== t4) {
    t11 = <tr className="vacancy-row" onClick={onClick}>{t2}{t4}{t10}</tr>;
    $[19] = onClick;
    $[20] = t10;
    $[21] = t2;
    $[22] = t4;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}
function _temp(s, i, arr) {
  return <div className="text-normal leading-tight" key={"start-addr-line-" + i}>{s} {arr.length > i + 1 && <br />}</div>;
}